module.exports = __webpack_public_path__ + "img/logo2.5c534be8.png";